<template>
  <div class="footer">
    <div class="row footer-top">
      <div class="footer-links">
        <div v-for="page in cms.list" class="footer-link">
          <router-link :to="{ name: 'showPage', params: { type: page.pagetype }}">{{page.title}}</router-link>
        </div>
        <div class="footer-link">
          <router-link :to="{ name: 'contact' }">Kontakt</router-link>
        </div>
        <div>
          <Page class="footer-page-template" type="FOOTER" />
        </div>
      </div>
    </div>

    <div class="footer-copy">
      <p class="footer-header">
        &copy; COPYRIGHT
        <span>VETDIRECT</span> SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ SPÓŁKA KOMANDYTOWA
      </p>
      <p class="footer-subheader">
        NIP:
        <span>1231383846</span> | REGON:
        <span>369134619</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Page } from "../RedbayComponents";

export default {
  components: { Page },
  computed: {
    ...mapState({
      cms: state => state.cms
    })
  },
  beforeMount() {
    this.$store.dispatch("cms/getList");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/Footer.vue